/** Fixed column width for milestone (non–phase-date) cells in the grid report. */
export const MILESTONE_GRID_COLUMN_WIDTH_PX = 140;

/** Phase / beta date columns stay on the narrower spec. */
export const PHASE_DATE_COLUMN_WIDTH_PX = 100;
